module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0900.923e1a3d.jpg";